import StudyManagement from './ui/studyManagement';

export default StudyManagement;
